import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 16 16'
    width={size || width}
    height={size || height}
    {...props}
  >
    <rect width={1.333} height={4} x={7.333} fill='currentColor' rx={0.667} />
    <rect width={1.333} height={4} x={7.333} y={12} fill='currentColor' rx={0.667} />
    <rect width={1.333} height={4} y={8.667} fill='currentColor' rx={0.667} transform='rotate(-90 0 8.667)' />
    <rect width={1.333} height={4} x={12} y={8.667} fill='currentColor' rx={0.667} transform='rotate(-90 12 8.667)' />
    <rect
      width={1.333}
      height={4}
      x={1.872}
      y={2.815}
      fill='currentColor'
      rx={0.667}
      transform='rotate(-45 1.872 2.815)'
    />
    <rect
      width={1.333}
      height={4}
      x={10.357}
      y={11.3}
      fill='currentColor'
      rx={0.667}
      transform='rotate(-45 10.357 11.3)'
    />
    <rect
      width={1.333}
      height={4}
      x={2.814}
      y={14.128}
      fill='currentColor'
      rx={0.667}
      transform='rotate(-135 2.814 14.128)'
    />
    <rect
      width={1.333}
      height={4}
      x={11.3}
      y={5.643}
      fill='currentColor'
      rx={0.667}
      transform='rotate(-135 11.3 5.643)'
    />
  </svg>
)
export default SvgComponent
